import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=79eb2aca&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=79eb2aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb2aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79eb2aca')) {
      api.createRecord('79eb2aca', component.options)
    } else {
      api.reload('79eb2aca', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=79eb2aca&scoped=true&", function () {
      api.rerender('79eb2aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22nZ4mBGEQlD7/JS/comp/CookieBox.vue"
export default component.exports